<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="toc"><a id="page_vii"></a><strong>CONTENTS</strong></h2>
<p class="tocfm"><a class="nounder" href="#/xhtml/illu">List of Illustrations</a></p>
<p class="tocfm"><a class="nounder" href="#/xhtml/maps">Maps</a></p>
<p class="tocfm"><a class="nounder" href="#/xhtml/cutaways">Cutaways</a></p>
<p class="tocfm"><a class="nounder" href="#/xhtml/pro">Prologue</a></p>
<p class="toc"><a class="nounder" href="#/xhtml/ch01">1 Déjà Vu</a></p>
<p class="toc"><a class="nounder" href="#/xhtml/ch02">2 Riding the Dragon</a></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch03" title="Link target outside of Sample">3 Handover</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch04" title="Link target outside of Sample">4 Back in the Hot Seat</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch05" title="Link target outside of Sample">5 Alice, Trigger, FOG and Rocco</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch06" title="Link target outside of Sample">6 Arnhem Calling</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch07" title="Link target outside of Sample">7 A Matter of Time</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch08" title="Link target outside of Sample">8 Op Glacier Begins</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch09" title="Link target outside of Sample">9 The Bobs and Steve-O</span></p>
<p class="toca"><span class="nounder" href="#/xhtml/ch10" title="Link target outside of Sample">10 Merry Christmas</span></p>
<p class="toca"><span class="nounder" href="#/xhtml/ch11" title="Link target outside of Sample">11 Ready To Go Noisy</span></p>
<p class="toca"><span class="nounder" href="#/xhtml/ch12" title="Link target outside of Sample">12 Op Glacier 1: Koshtay</span></p>
<p class="toca"><span class="nounder" href="#/xhtml/ch13" title="Link target outside of Sample">13 A Good Night’s Work</span></p>
<p class="toca"><span class="nounder" href="#/xhtml/ch14" title="Link target outside of Sample">14 Op Glacier 2: The Jugroom Fort</span></p>
<p class="toca"><span class="nounder" href="#/xhtml/ch15" title="Link target outside of Sample">15 Finding Mathew Ford</span></p>
<p class="toca"><a id="page_viii"></a><span class="nounder" href="#/xhtml/ch16" title="Link target outside of Sample">16 Give Me Four Volunteers</span></p>
<p class="toca"><span class="nounder" href="#/xhtml/ch17" title="Link target outside of Sample">17 Into The Lion’s Mouth</span></p>
<p class="toca"><span class="nounder" href="#/xhtml/ch18" title="Link target outside of Sample">18 The Wrong Wall</span></p>
<p class="toca"><span class="nounder" href="#/xhtml/ch19" title="Link target outside of Sample">19 Escaping Jugroom Fort</span></p>
<p class="toca"><span class="nounder" href="#/xhtml/ch20" title="Link target outside of Sample">20 In Command: The Verdict</span></p>
<p class="tocbm"><span class="nounder" href="#/xhtml/epi" title="Link target outside of Sample">Epilogue</span></p>
<p class="tocbm"><span class="nounder" href="#/xhtml/glo" title="Link target outside of Sample">Glossary of Terms</span></p>
<p class="tocbm"><span class="nounder" href="#/xhtml/ack" title="Link target outside of Sample">Acknowledgements</span></p>
<p class="tocbm"><span class="nounder" href="#/xhtml/index" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?33504422